export type Theme = "light" | "dark" | "system";

const STORAGE_KEY = "url_sensor.theme";

export function getStoredTheme(): Theme {
  if (typeof window === "undefined") return "system";
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === "light" || raw === "dark" || raw === "system" ? raw : "system";
}

export function resolveTheme(t: Theme): "light" | "dark" {
  if (t !== "system") return t;
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyTheme(t: Theme): void {
  if (typeof document === "undefined") return;
  const effective = resolveTheme(t);
  const root = document.documentElement;
  root.classList.toggle("dark", effective === "dark");
  root.style.colorScheme = effective;
}

export function setTheme(t: Theme): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, t);
  }
  applyTheme(t);
}

export function initTheme(): void {
  const t = getStoredTheme();
  applyTheme(t);
  if (typeof window !== "undefined" && t === "system") {
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (): void => {
      if (getStoredTheme() === "system") applyTheme("system");
    };
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
  }
}
